export default __webpack_public_path__ + "static/media/loading.741f09b2.gif";